import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  avatarUrl?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email: string;
  className?: string;
  fallbackClassName?: string;
}

const UserAvatar = ({ avatarUrl, firstName, lastName, email, className, fallbackClassName }: UserAvatarProps) => {
  const getInitials = () => {
    if (firstName && lastName) {
      return (firstName[0] + lastName[0]).toUpperCase();
    } else if (firstName) {
      return firstName[0].toUpperCase();
    }
    return email[0].toUpperCase();
  };

  return (
    <Avatar className={className}>
      {avatarUrl && <AvatarImage src={avatarUrl} alt="Profile" />}
      {/* `.avatar-plate` (index.css) rather than `bg-primary/10`: the
          initials plate is a solid object, and a 90%-transparent one lets
          whatever is behind it — another avatar, in a stack — read straight
          through the face. Same colour, pre-composited over the card. */}
      <AvatarFallback className={cn("avatar-plate text-primary dark:text-blue-200 font-semibold", fallbackClassName)}>
        {getInitials()}
      </AvatarFallback>
    </Avatar>
  );
};

export default UserAvatar;
